const translations = {
  "en": {
    "Upgrade": "Upgrade"
  },
  "zh-tw": {
    "Upgrade": "升級"
  }
};

export default translations;
